import { IToasts, ToastContext, ToastProps } from "@/contexts/toastContext";
import { useContext } from "react";

export type ToastAction = { type: "ADD_TOAST"; payload: ToastProps } | { type: "DELETE_TOAST"; payload: string };
  
export const toastReducer = (state: IToasts, action: ToastAction) => {
	switch (action.type) {
		case "ADD_TOAST":
			return {
				...state,
				toasts: [...state.toasts, action.payload],
			};
		case "DELETE_TOAST": {
			const updatedToasts = state.toasts.filter(
				(toast) => toast.id !== action.payload
			);
			return {
				...state,
				toasts: updatedToasts,
			};
		}
		default:
			throw new Error(`Unhandled action type: ${(action as ToastProps).type}`);
	}
};

export const useToast = () => {
	const context = useContext(ToastContext);

	if (!context) { 
		throw new Error("ToastContext was used outside of its Provider")
	}

	return context
}